import React from "react";

/*
    Help Icon
    props:
        - title: string, override the default title 'Help'
        - color: string, override the default color '#00549A' (bell blue)
*/

const HelpIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Help"}</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8337 6.16625C21.0554 9.38838 21.0554 14.6116 17.8337 17.8337C14.6121 21.0554 9.38792 21.0554 6.16625 17.8337C2.94458 14.6116 2.94458 9.38838 6.16625 6.16625C9.38792 2.94458 14.6121 2.94458 17.8337 6.16625Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9887 8C11.2873 8 10.6 8.64865 10.6 9.60346C10.6 10.0177 10.2642 10.3535 9.84998 10.3535C9.43576 10.3535 9.09998 10.0177 9.09998 9.60346C9.09998 7.95874 10.3268 6.5 11.9887 6.5C13.6497 6.5 14.8778 7.95844 14.8778 9.60346C14.8778 10.3998 14.5976 11.1365 14.1249 11.6936C14.1195 11.7 14.1139 11.7064 14.1082 11.7126L12.8206 13.1299V13.9722C12.8206 14.3864 12.4848 14.7222 12.0706 14.7222C11.6564 14.7222 11.3206 14.3864 11.3206 13.9722V12.8401C11.3206 12.6536 11.3901 12.4738 11.5155 12.3358L12.9886 10.7143C13.225 10.4314 13.3778 10.0428 13.3778 9.60346C13.3778 8.64896 12.6898 8 11.9887 8Z"
            fill={props.color || "#00549A"}
        />
        <path
            d="M12.8206 16.8171C12.8206 17.2313 12.4848 17.5671 12.0706 17.5671C11.6564 17.5671 11.3206 17.2313 11.3206 16.8171C11.3206 16.4028 11.6564 16.0671 12.0706 16.0671C12.4848 16.0671 12.8206 16.4028 12.8206 16.8171Z"
            fill={props.color || "#00549A"}
        />
    </svg>
);

export default HelpIcon;
